import script from "./FaqViews.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqViews.vue?vue&type=script&setup=true&lang=js"

import "./FaqViews.vue?vue&type=style&index=0&id=cb5d2cd2&lang=css"

const __exports__ = script;

export default __exports__